import './location.css';

import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { useCallback, useMemo } from 'react';
import { iconLocation, iconSearch } from '../../util/icons';

export interface LocationProps {
  defaultValue: string;
  setLocationAutocompleteValue(value: google.maps.places.AutocompletePrediction | null): void;
  centerMapToLocation(): void;
  centerMapToPlace(): void;
}

export interface AutoResponseItem {
  label: string;
  value: google.maps.places.AutocompletePrediction;
  locationAutocomplete: google.maps.places.Autocomplete;
}

export const Location = (props: LocationProps) => {

  const selectPlace = useCallback((item: AutoResponseItem) => {
    item !== null &&
      props.setLocationAutocompleteValue(item.value);
  }, [props]);

  const LocationOption = useCallback((nprops: any) => {
    const { innerRef } = nprops;

    return (
      <div ref={innerRef}>
        <div className="location-option" onClick={props.centerMapToLocation}><span className="location-option-icon">{iconLocation}</span> Current Location</div>
      </div>
    );
  }, [props.centerMapToLocation]);

  const selectProps = useMemo(() => ({
      placeholder: 'Enter location',
      components: { NoOptionsMessage: LocationOption, DropdownIndicator: () => null, IndicatorSeparator: () => null },
      styles: {
        control: (provided: any, state: any) => ({
          ...provided, fontSize: '1em', minHeight: 'unset', height: '2.5em', cursor: 'pointer', borderWidth: '1px', borderStyle: 'solid', boxShadow: 'unset', borderRadius: 'var(--default-corner-radius)', borderTopRightRadius: 0, borderBottomRightRadius: 0, borderColor: state.isFocused ? "var(--primary-color)" : "var(--default-border-color-light)", backgroundColor: "var(--default-background-color)",
          "&:hover": {
            borderColor: state.isFocused ? "var(--primary-color)" : "var(--default-border-color-dark)"
          }
        }),
        input: (provided: any) => ({ ...provided, color: 'var(--default-font-color-dark)' }),
        placeholder: (provided: any) => ({ ...provided, color: 'var(--default-font-color-light)' }),
        singleValue: (provided: any) => ({ ...provided, color: 'var(--default-font-color-dark)' }),
        menu: (provided: any) => ({ ...provided, minWidth: '20em', width: 'fit-content', backgroundColor: 'var(--default-background-color)', borderRadius: 'var(--default-corner-radius)' }),
        option: (provided: any, state: any) => ({
          ...provided, cursor: 'pointer', color: state.isSelected ? 'var(--default-background-color)' : 'var(--default-font-color-dark)', backgroundColor: state.isSelected ? "var(--primary-color)" : "var(--default-background-color)", padding: '.5em !important', margin: '0',
          "&:hover": {
            backgroundColor: state.isSelected ? "var(--primary-color)" : "var(--primary-results-highlight-color)",
            color: state.isSelected ? "var(--default-background-color)" : 'var(--default-font-color-dark)'
          }
        })
      },
      defaultValue: props.defaultValue,
      onChange: selectPlace,
      id: 'location-select'
  }), [LocationOption, props.defaultValue, selectPlace]);


  return (
    <div className="location-wrapper">
      <div className="location-div">
        <GooglePlacesAutocomplete
          autocompletionRequest={{
            componentRestrictions: {
              country: ['ca']
            }
          }}
          selectProps={selectProps}
        />
      </div>
      <div className="location-button-div">
        <button className="location-position-button" onClick={props.centerMapToPlace}>{iconSearch}</button>
      </div>
    </div>
  );
}
